import Collection from 'ol/Collection';
import {Style, Fill, Stroke, Text} from 'ol/style';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';


function getJunctionLayer(waypoints) {
    const features = new Collection();
    waypoints.forEach(waypoint => {
        let code = waypoint.get('name');

        waypoint.setStyle(
            new Style({
                text: new Text({
                    text: code,
                    font: 'bold 14px Calibri,sans-serif',
                    justify: 'center',
                    fill: new Fill({
                        color: '#fff'
                    }),
                    padding: [3, 0, 0, 3],
                    backgroundFill: new Fill({
                        color: 'green'
                    })
                })
            })
        );
        features.push(waypoint);
    });
    return getLayer(features, 'Junctions');
}

function getPointLayer(waypoints) {
    const features = new Collection();
    waypoints.forEach(waypoint => {
        let name = waypoint.get('name');
        if (name.indexOf('A:') == 0) {
            name = name.replace('A:', 'Aussichtspunkt \n');
        } else if (name.indexOf('H:') == 0) {
            name = name.replace('H:', 'Bushaltestelle \n');
        } else if (name.indexOf('P:') == 0) {
            name = name.replace('P:', 'Parkplatz \n');
        } else if (name.indexOf('WS:') == 0) {
            name = name.replace('WS:', 'Wegespinne \n');
        }
        
        waypoint.setStyle(
            new Style({
                text: new Text({
                    text: name,
                    font: 'bold 10px Calibri,sans-serif',
                    fill: new Fill({
                        color: '#000'
                    }),
                    padding: [2, 2, 2, 2],
                    backgroundFill: new Fill({
                        color: '#fff'
                    })
                })
            })
        );
        features.push(waypoint);
    });
    return getLayer(features, 'Wegepunkte');
}

function getWanderpunkteLayer(wanderpunkte) {
    const features = new Collection();
    wanderpunkte.forEach(wanderpunkt => {
        let name = wanderpunkt.get('punktname');
        
        wanderpunkt.setStyle(
            new Style({
                text: new Text({
                    text: name.replace("_", " "),
                    font: 'bold 10px Calibri,sans-serif',
                    fill: new Fill({
                        color: '#000'
                    }),
                    padding: [2, 2, 2, 2],
                    backgroundFill: new Fill({
                        color: '#fff'
                    })
                })
            })
        );
        features.push(wanderpunkt);
    });
    return getLayer(features, 'Wanderpunkte');
}

function getLayer(features, type) {
    const source = new VectorSource({
        name: type,
        features: features
    });
    const layer = new VectorLayer({
        source: source,
    });
    return layer;
}

const Wanderpunkte = {};
Wanderpunkte.getPointLayer = getPointLayer;
Wanderpunkte.getWanderpunkteLayer = getWanderpunkteLayer;
Wanderpunkte.getJunctionLayer = getJunctionLayer;
export default Wanderpunkte;
